const config = {
    twitter: {
        apiKey: "F3O78kizuWc5AYPYMq4zpGHUh",
        apiSecretKey: "QED2gVrSvjb1SyOgVCIJwlzdPklvYs7T89QAvnZFSZLuY6xB5t",
        bearerToken: "AAAAAAAAAAAAAAAAAAAAAL1cIgEAAAAAyPYttziHtt8LglqbqX4VO8lwG3o%3Dkd8uvFHjtGejsPPqz620oyMPP5MjD0s1YRCWoCB7yumMNFPBvU",
        stripe: {
            publicKey: "pk_test_51HZXZyLFGJnOD6GVEcc0P0t9P4tQFfHK3WLs3ekS40DeqsNnJCJQJrFOKDVhXl2dCFy7PJhEzsZpL7hg0oEpkffk00EQLdREMe",
            secretKey: "sk_test_51HZXZyLFGJnOD6GVM0n0mIn1fpx0N4emgmAkEXW90iEee0NLBbx4br7waf8sPWIHKgAtuQQzzmgJ6mdIy7OYF7xx00n3i4pqK5",
        },
    },
    info: {
        threadokHashtag: 'threadok',
        teoTwitter: 'teodora_dobre',
        luisTwitter: 'rescoluis',
        twitterShareText: '🧵 A site to find threads selecting topics you like'
    },
    firebase: {
        config: {
            apiKey: "AIzaSyCcJWD-Y_aCeC1yfZbjCGDY27EvEUx5oTc",
            authDomain: "threadok-6b128.firebaseapp.com",
            databaseURL: "https://threadok-6b128.firebaseio.com",
            projectId: "threadok-6b128",
            storageBucket: "threadok-6b128.appspot.com",
            messagingSenderId: "58377063583",
            appId: "1:58377063583:web:d023eaba751fcb8af426aa",
            measurementId: "G-NZZ37E1RG8"
        },
        remoteFetchIntervalMillis: 0,
        messagingKey: "BEL7klr31uQVP0t-y4J1hUg_17HwL7w5SgLhjhXCXD-B6mJ4JcFN5FVHJ7EnroXvwMwd5wQWlH_gqonIOy41qZg",
    },
};

module.exports = config